export const LIST_NAME = `planTypeTemplates`
export const getBasicUrl = planTypeId =>
  `/plan/types/${planTypeId}/reports/templates`
